import { styleSwedishLocale } from './styleSwedishLocale.esm.js';
import { styleEnglishLocale } from './styleEnglishLocale.esm.js';

/**
 * Format a date or date-parseable string
 *
 * @param {Date | string} date - Input date to format
 *
 * @param {Options} options - Locale and timeZone options, plus Intl.DateTimeFormatOptions base options
 *
 */
const formatter = (date, options) => {
    var _a;
    const locale = (_a = options === null || options === void 0 ? void 0 : options.locale) !== null && _a !== void 0 ? _a : 'sv-SE';
    const dt = date instanceof Date ? date : new Date(Date.parse(date));
    const format = new Intl.DateTimeFormat(locale, Object.assign(Object.assign({}, options), { timeZone: (options === null || options === void 0 ? void 0 : options.timeZone) !== 'local-time' ? 'Europe/Stockholm' : undefined })).format(dt);
    switch (locale) {
        case 'sv-SE':
            return styleSwedishLocale(format);
        case 'en-GB':
            return styleEnglishLocale(format);
    }
};
/**
 * Format a date range between two dates or date-parseable strings
 *
 * @param {Date | string} fromDate - Input date start
 *
 * @param {Date | string} toDate - Input date end
 *
 * @param {Options} options - Locale and timeZone options, plus Intl.DateTimeFormatOptions base options
 *
 */
const rangeFormatter = (fromDate, toDate, options) => {
    var _a;
    const locale = (_a = options === null || options === void 0 ? void 0 : options.locale) !== null && _a !== void 0 ? _a : 'sv-SE';
    const fromDt = fromDate instanceof Date ? fromDate : new Date(Date.parse(fromDate));
    const toDt = toDate instanceof Date ? toDate : new Date(Date.parse(toDate));
    const form = new Intl.DateTimeFormat(locale, Object.assign(Object.assign({}, options), { timeZone: (options === null || options === void 0 ? void 0 : options.timeZone) !== 'local-time' ? 'Europe/Stockholm' : undefined }));
    switch (locale) {
        case 'sv-SE':
            return styleSwedishLocale(form.formatRange(fromDt, toDt));
        case 'en-GB':
            return styleEnglishLocale(form.formatRange(fromDt, toDt));
    }
};

export { formatter, rangeFormatter };
